import { i18n, Row, Form, Cell, http } from "@common";
import { useState, useCallback, useRef, useImperativeHandle, forwardRef, useEffect } from "react";
import { AccountStatus } from "../constant";
import { adminService } from "@api";

const isAzure = "By Azure AD";

const Edit = (props) => {
    const { status, ...others } = props;
    const pageRef = useRef();

    const button = [
        {
            text: i18n.get("Common_Cancel_Entry"),
            name: "cancel",
            onClick: () => pageRef.current.onPanelButtonClick("cancel"),
        },
        {
            text: i18n.get("Common_Save_Entry"),
            classify: "info",
            name: "save",
            disabled: others?.item?.accountStatus === '2' || others?.item?.statusReason === isAzure,
            onClick: () => pageRef.current.onPanelButtonClick('save'),
        }];

    return (
        <R.Panel
            id="panel-claim-item-edit"
            title={i18n.get("CIS_Admin_StudentManagement_Edit_Title_Entry")}
            status={status}
            buttons={button}
            willClose={() => pageRef.current.onPanelButtonClick('cancel')}
        >
            <Content {...others} ref={pageRef} />
        </R.Panel>
    );
};

const Content = forwardRef((props, refs) => {
    const [formItems, setFormItems] = useState({});
    const formRef = useRef();
    const { reloadTable, item } = props;

    useEffect(() => {
        setFormItems(item);
    }, [item]);

    const willClose = useCallback(() => {
        return formRef.current.areyousure.check();
    }, []);

    const onSave = useCallback(() => {
        if (!formRef.current.validate()) {
            return false;
        }
        let param = {
            objectid: formItems.objectId,
            status: formItems.accountStatus
        };
        $$.loading(true);
        return adminService.studentManagementUpdate(param).then(request => {
            $$.loading(false);
            reloadTable(false, i18n.get('CIS_Admin_StudentManagement_Update_Message'));
        }).catch(e => {
            $$.loading(false);
            if (e?.errorCode === http.ErrorCode.CatchErrorCode) {
                $$.toast(e?.message, 'warning');
            } else {
                $$.toast(i18n.get('CIS_Admin_StudentManagement_UpdateFailed_Message'), 'error');
            }
            throw e;
        });
    }, [formItems, reloadTable]);

    useImperativeHandle(refs, () => ({
        onPanelButtonClick: name => {
            switch (name) {
                case 'save':
                    $$.confirm(true, {
                        title: i18n.get("Common_Save_Entry"),
                        content: i18n.get('CIS_Admin_StudentManagement_Edit_confirm_content_Entry'),
                        buttons: [
                            { text: i18n.get('Common_No_Entry') },
                            {
                                text: i18n.get('Common_Yes_Entry'), classify: 'theme', onClick: onSave
                            }
                        ]
                    });
                    return false;
                case 'cancel':
                    return willClose();
                default:
                    return false;
            }
        }
    }), [onSave, willClose]);

    const handleCheckChange = (key, value) => {
        setFormItems(item => ({
            ...item,
            [key]: value === true ? String(AccountStatus.Enabled) : String(AccountStatus.Disabled)
        }));
    };
    return (
        <Form ref={formRef}>
            <Row>
                <Cell label={i18n.get("CIS_Admin_StudentManagement_Edit_StudentID_Entry")}>
                    <R.Input
                        disabled
                        id="input-student-management-student-id"
                        attrs={{ "aria-labelledby": Form.formlabel }}
                        type="text"
                        value={formItems.studentId}
                    />
                </Cell>
            </Row>
            <Row>
                <Cell label={i18n.get("CIS_Admin_StudentManagement_Edit_DisplayName_Entry")}>
                    <R.Input
                        disabled
                        id="input-student-management-display-name"
                        attrs={{ "aria-labelledby": Form.formlabel }}
                        type="text"
                        value={formItems.displayName}
                    />
                </Cell>
            </Row>
            <Row>
                <Cell label={i18n.get("CIS_Admin_StudentManagement_Edit_Email_Entry")}>
                    <R.Input
                        disabled
                        id="input-student-management-email"
                        attrs={{ "aria-labelledby": Form.formlabel }}
                        type="text"
                        value={formItems.email}
                    />
                </Cell>
            </Row>
            <Row>
                <Cell label={i18n.get("CIS_Admin_StudentManagement_Edit_Account_status_Entry")}>
                    <R.Checkbox
                        name="checkbox-student-management-account-status"
                        text={i18n.get('CIS_Admin_StudentManagement_Filter_Enabled_Entry')}
                        checked={Number(formItems.accountStatus) === AccountStatus.Enabled}
                        disabled={Number(formItems.accountStatus) === AccountStatus.Syncing || formItems.statusReason === isAzure}
                        onChange={(value) => {
                            handleCheckChange('accountStatus', value);
                        }}
                    />
                </Cell>
            </Row>
        </Form>
    );
});

export default Edit;